import { Box } from "@mui/material";
import MuiTypography from "@mui/material/Typography";
import styled from "styled-components";

export const Content = styled(Box)`
  padding: 16px 8px 16px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Overview = styled(Box)`
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 48px;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(0, 0, 0, 0.04);
`;

export const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
`;

export const OverviewTextWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  align-self: stretch;
`;

export const Subject = styled(MuiTypography)`
  color: #1d1d1d;
  font-family: Noto Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const DateText = styled(MuiTypography)`
  color: #979797;
  font-family: Noto Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const Title = styled(MuiTypography)`
  color: #1d1d1d;
  font-family: Noto Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const TypographyWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  white-space: pre-wrap;
  margin-bottom: 30px;
`;

export const DetailsWrapper = styled(Box)`
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const DetailsInfoWrapper = styled(Box)`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  gap: 10px;
  padding: 10px 18px 5px 18px;
  border-radius: 0px 0px 10px 10px;
  background: var(--colours-primary-white, #fff);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
`;

export const InfoWrapper = styled(Box)`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  align-self: stretch;
`;

export const InfoTextName = styled(MuiTypography)`
  color: #1d1d1d;
  max-width: 30%;
  text-align: left;
  font-family: Noto Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const InfoTextValue = styled(MuiTypography)`
  color: #1d1d1d;
  max-width: 69%;
  text-align: right;
  font-family: Noto Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
